import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { Platform, StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

export const NutritionInformationWrapper = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[
        styles.nutritionInformationWrapper,
        isDesktop && styles.nutritionInformationWrapperDesktop,
        Platform.OS === 'android' && styles.nutritionInformationWrapperAndroid,
        style,
      ]}
    />
  );
};

export const NutritionInformationTitle = withTypography({
  variant: 'headerThree',
  lineHeight: 'lg',
});

export const NutritionInformationContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[
        styles.nutritionInformationContainer,
        isDesktop && styles.nutritionInformationContainerDesktop,
        style,
      ]}
    />
  );
};

export const AllergensDisclaimerContainer = Text.withConfig({
  variant: 'copyTwo',
  marginBottom: '$4',
  fontSize: 'xs',
});

export const AllergenNames = Text.withConfig({
  variant: 'copyTwo',
  fontWeight: 'bold',
});

const styles = StyleSheet.create({
  nutritionInformationContainer: {
    marginVertical: 8,
  },
  nutritionInformationContainerDesktop: {
    marginVertical: 24,
  },
  nutritionInformationWrapper: {
    paddingHorizontal: 16,
  },
  nutritionInformationWrapperAndroid: {
    height: '100%',
  },
  nutritionInformationWrapperDesktop: {
    paddingHorizontal: 0,
  },
});
